<template>
    <div id="tryout-form">
        <!-- Begin of Form -->
        <v-card text>
            <!-- Tryout Form items -->
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Judul *
                    </v-list-item-title>
                    <v-text-field
                        id="tryout_judul"
                        placeholder="Judul Tryout"
                        :disabled="!auth.scopes.includes('admin_itembank')"
                        v-model="tryout.name"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Deskripsi *
                    </v-list-item-title>
                    <v-textarea
                        id="tryout_deskripsi"
                        placeholder="Deskripsi Tryout"
                        :disabled="!auth.scopes.includes('admin_itembank')"
                        v-model="tryout.description"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Jenjang *
                    </v-list-item-title>

                    <v-radio-group
                        row
                        :disabled="!auth.scopes.includes('admin_itembank')"
                        v-model="tryout.level"
                    >
                        <v-radio
                            id="tryout_jenjang_umum"
                            label="Umum"
                            value="UMUM"
                            class="jenjang-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                        <v-radio
                            id="tryout_jenjang_sma"
                            label="SMA"
                            value="SMA"
                            class="jenjang-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                        <v-radio
                            id="tryout_jenjang_smp"
                            label="SMP"
                            value="SMP"
                            class="jenjang-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                        <v-radio
                            id="tryout_jenjang_sd"
                            label="SD"
                            value="SD"
                            class="jenjang-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                    </v-radio-group>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="px-0 pt-0 pb-4">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Tipe *
                    </v-list-item-title>
                    <div id="tryout_tipe">
                        <v-select
                            placeholder="Pilih Tipe"
                            outlined
                            class="pa-0"
                            :disabled="!auth.scopes.includes('admin_itembank')"
                            v-model="tryout.type"
                            :items="[
                                { text: 'SBMPTN', value: 'SBMPTN' },
                                {
                                    text: 'Ujian Nasional (UN)',
                                    value: 'UJIAN_AKHIR_NASIONAL',
                                },
                                {
                                    text: 'Ujian Akhir Sekolah (UAS)',
                                    value: 'UJIAN_AKHIR_SEKOLAH',
                                },
                                {
                                    text: 'Ujian Sekolah',
                                    value: 'UJIAN_SEKOLAH',
                                },
                            ]"
                        ></v-select>
                    </div>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                two-line
                class="px-0 pt-0 pb-4"
                v-if="tryout.type == 'SBMPTN'"
            >
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Kategori *
                    </v-list-item-title>

                    <div id="tryout_kategori">
                        <v-select
                            placeholder="Pilih Kategori"
                            outlined
                            class="pa-0"
                            :disabled="!auth.scopes.includes('admin_itembank')"
                            v-model="tryout.category"
                            :items="[
                                { text: 'TPS', value: 'TPS' },
                                { text: 'SAINTEK', value: 'SAINTEK' },
                                {
                                    text: 'SOSHUM',
                                    value: 'SOSHUM',
                                },
                                {
                                    text: 'LITERASI',
                                    value: 'LITERASI',
                                },
                            ]"
                        ></v-select>
                    </div>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                two-line
                class="px-0 pt-0 pb-4"
                v-else-if="tryout.type == 'UJIAN_AKHIR_NASIONAL'"
            >
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Kategori *
                    </v-list-item-title>

                    <div id="tryout_kategori">
                        <v-select
                            placeholder="Pilih Kategori"
                            outlined
                            class="pa-0"
                            :disabled="!auth.scopes.includes('admin_itembank')"
                            v-model="tryout.category"
                            :items="[
                                { text: 'SAINTEK', value: 'SAINTEK' },
                                {
                                    text: 'SOSHUM',
                                    value: 'SOSHUM',
                                },
                            ]"
                        ></v-select>
                    </div>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="px-0 pt-0 pb-4" v-else>
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Kategori *
                    </v-list-item-title>

                    <div id="tryout_kategori">
                        <v-select
                            placeholder="Pilih Kategori"
                            outlined
                            class="pa-0"
                            :disabled="!auth.scopes.includes('admin_itembank')"
                            v-model="tryout.category"
                            :items="[{ text: 'OTHER', value: 'OTHER' }]"
                        ></v-select>
                    </div>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Durasi (Menit) *
                    </v-list-item-title>
                    <v-text-field
                        id="tryout_durasi"
                        :disabled="!auth.scopes.includes('admin_itembank')"
                        v-model="tryout.duration"
                        type="number"
                        placeholder="(menit)"
                        suffix="menit"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Jenis
                    </v-list-item-title>
                    <v-checkbox
                        id="tryout_jenis_instant"
                        label="Instant"
                        :disabled="!auth.scopes.includes('admin_itembank')"
                        v-model="tryout.is_repeated"
                        class="pa-0 ma-0"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item class="pa-0">
                <v-row>
                    <v-col cols="6">
                        <v-list-item two-line class="py-0 px-1">
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Waktu Mulai *
                                </v-list-item-title>
                                <v-container>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-menu
                                                ref="menu"
                                                v-model="
                                                    tryout.start_date.option
                                                "
                                                :close-on-content-click="false"
                                                transition="slide-y-reverse-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-text-field
                                                        id="tryout_durasi_start_date"
                                                        v-model="
                                                            tryout.start_date
                                                                .value
                                                        "
                                                        append-icon="mdi-calendar"
                                                        placeholder="Tanggal"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        outlined
                                                        :disabled="
                                                            !auth.scopes.includes(
                                                                'admin_itembank',
                                                            )
                                                        "
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="
                                                        tryout.start_date.value
                                                    "
                                                    no-title
                                                    scrollable
                                                    @change="
                                                        tryout.start_date.option = false
                                                    "
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-menu
                                                ref="menu1"
                                                v-model="
                                                    tryout.start_time.option
                                                "
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="slide-y-reverse-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-text-field
                                                        id="tryout_durasi_start_time"
                                                        v-model="
                                                            tryout.start_time
                                                                .value
                                                        "
                                                        outlined
                                                        placeholder="Jam"
                                                        append-icon="mdi-clock-time-four-outline"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :disabled="
                                                            !auth.scopes.includes(
                                                                'admin_itembank',
                                                            )
                                                        "
                                                    ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="
                                                        tryout.start_time.option
                                                    "
                                                    v-model="
                                                        tryout.start_time.value
                                                    "
                                                    format="24hr"
                                                    @input="
                                                        tryout.start_time.value =
                                                            tryout.start_time
                                                                .value
                                                                ? tryout
                                                                      .start_time
                                                                      .value +
                                                                  ':00'
                                                                : null
                                                    "
                                                    @click:minute="
                                                        $refs.menu1.save(
                                                            tryout.start_time
                                                                .value,
                                                        )
                                                    "
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                    <v-col cols="6">
                        <v-list-item two-line class="py-0 px-1">
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Waktu Berakhir *
                                </v-list-item-title>
                                <v-container>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-menu
                                                ref="menu"
                                                v-model="tryout.end_date.option"
                                                :close-on-content-click="false"
                                                transition="slide-y-reverse-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-text-field
                                                        id="tryout_durasi_end_date"
                                                        v-model="
                                                            tryout.end_date
                                                                .value
                                                        "
                                                        append-icon="mdi-calendar"
                                                        placeholder="Tanggal"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        outlined
                                                        :disabled="
                                                            !auth.scopes.includes(
                                                                'admin_itembank',
                                                            )
                                                        "
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="
                                                        tryout.end_date.value
                                                    "
                                                    no-title
                                                    scrollable
                                                    @change="
                                                        tryout.end_date.option = false
                                                    "
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-menu
                                                ref="menu"
                                                v-model="tryout.end_time.option"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="slide-y-reverse-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-text-field
                                                        id="tryout_durasi_end_time"
                                                        v-model="
                                                            tryout.end_time
                                                                .value
                                                        "
                                                        outlined
                                                        placeholder="Jam"
                                                        append-icon="mdi-clock-time-four-outline"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :disabled="
                                                            !auth.scopes.includes(
                                                                'admin_itembank',
                                                            )
                                                        "
                                                    ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="
                                                        tryout.end_time.option
                                                    "
                                                    v-model="
                                                        tryout.end_time.value
                                                    "
                                                    format="24hr"
                                                    @input="
                                                        tryout.end_time.value =
                                                            tryout.end_time
                                                                .value
                                                                ? tryout
                                                                      .end_time
                                                                      .value +
                                                                  ':00'
                                                                : null
                                                    "
                                                    @click:minute="
                                                        $refs.menu.save(
                                                            tryout.end_time
                                                                .value,
                                                        )
                                                    "
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-list-item>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    id="tryout_simpan"
                    color="blew"
                    @click="submit()"
                    depressed
                    dark
                >
                    Selanjutnya
                </v-btn>
            </v-card-actions>
        </v-card>
        <!-- End of Form -->
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutService from "@/modules/tryout/services/tryout.js";

export default {
    name: "tryout-form",

    components: {
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            errors: [],
            tryout: {
                id: 0,
                is_repeated: false,
                is_free_access: false,
                category: "OTHER",
                start_time: {
                    option: false,
                    value: null,
                },
                start_date: {
                    option: false,
                    value: null,
                },
                end_date: {
                    option: false,
                    value: null,
                },
                end_time: {
                    option: false,
                    value: null,
                },
            },
        };
    },

    computed: {
        ...mapState(["auth"]),
    },

    methods: {
        // save tryout then trigger storeTryoutAndCompleteTransaction if success
        submit: function () {
            var context = this;

            if (this.auth.scopes.includes("admin_itembank")) {
                if (this.validateForm()) {
                    var params = this.tryout;
                    params.start_date = params.start_date.value;
                    params.end_date = params.end_date.value;
                    params.start_time = params.start_time.value;
                    params.end_time = params.end_time.value;
                    context.isLoading = true;
                    if (this.tryout.id == 0) {
                        TryoutService.saveTryout(params, function (result) {
                            context.isLoading = false;
                            if (result.success) {
                                context.storeTryoutAndCompleteTransaction(
                                    result.data,
                                );
                            }
                        });
                    } else {
                        TryoutService.updateTryout(params, function (result) {
                            context.isLoading = false;
                            if (result.success) {
                                context.storeTryoutAndCompleteTransaction(
                                    result.data,
                                );
                            }
                        });
                    }
                } else {
                    $(window).scrollTop(0);
                }
            } else {
                this.$store.commit("showAlert", {
                    message: `Anda tidak memiliki akses untuk edit Tryout!`,
                    type: "error",
                });
            }
        },
        // regenerate Tryout that given then notify to tryout_init and completed
        storeTryoutAndCompleteTransaction: function (data) {
            data.end_date = { value: data.end_date, option: false };
            data.start_date = { value: data.start_date, option: false };
            data.end_time = { value: data.end_time, option: false };
            data.start_time = { value: data.start_time, option: false };
            this.$store.commit("tryout_init", data);
            this.$store.commit("showAlert", {
                message: `Tryout telah berhasil disimpan!`,
                type: "success",
            });
            this.$emit("completed");
        },
        // validation tryout
        validateForm: function () {
            var errors = false;

            if (!this.tryout.name) {
                this.$store.commit("showAlert", {
                    message: `Judul Tryout!`,
                    submessage: `Judul wajib diisi!`,
                    type: "error",
                });
                errors = true;
            } else if (!this.tryout.description) {
                this.$store.commit("showAlert", {
                    message: `Deskripsi Tryout!`,
                    submessage: `Deskripsi wajib diisi!`,
                    type: "error",
                });
                errors = true;
            } else if (!this.tryout.level) {
                this.$store.commit("showAlert", {
                    message: `Jenjang Tryout!`,
                    submessage: `Jenjang wajib diisi!`,
                    type: "error",
                });
                errors = true;
            } else if (!this.tryout.type) {
                this.$store.commit("showAlert", {
                    message: `Tipe Tryout!`,
                    submessage: `Tipe wajib diisi!`,
                    type: "error",
                });
                errors = true;
            } else if (!this.tryout.category) {
                this.$store.commit("showAlert", {
                    message: `Kategori Tryout!`,
                    submessage: `Kategori wajib diisi!`,
                    type: "error",
                });
                errors = true;
            } else if (
                (!this.tryout.duration && this.tryout.duration != 0) ||
                this.tryout.duration === null ||
                this.tryout.duration === "" ||
                this.tryout.duration < 0
            ) {
                this.$store.commit("showAlert", {
                    message: `Durasi Tryout!`,
                    submessage: `Durasi wajib diisi!`,
                    type: "error",
                });
                errors = true;
            }

            let startTimeFull = moment(
                `${this.tryout.start_date.value} ${this.tryout.start_time.value}`,
            ).format();
            let endTimeFull = moment(
                `${this.tryout.end_date.value} ${this.tryout.end_time.value}`,
            ).format();

            if (moment(startTimeFull).isBefore(moment().format())) {
                this.$store.commit("showAlert", {
                    message: `Waktu Mulai!`,
                    submessage: `Tanggal dan waktu mulai sudah lewat!`,
                    type: "error",
                });
                errors = true;
            } else {
                if (!moment(endTimeFull).isAfter(startTimeFull)) {
                    this.$store.commit("showAlert", {
                        message: `Waktu Berakhir!`,
                        submessage: `Tanggal dan waktu mulai harus melebihi tanggal dan waktu berakhir!`,
                        type: "error",
                    });
                    errors = true;
                }
            }

            return !errors;
        },
        // not used
        allowedSec: function (v) {
            if (v === this.tryout.start_time.value) {
                this.tryout.start_time.value = null;
                this.tryout.start_time.value = v + ":00";
            }

            if (v === this.tryout.end_time.value) {
                this.tryout.end_time.value = null;
                this.tryout.end_time.value = v + ":00";
            }
        },
    },

    mounted: function () {
        // init calendar and time object
        var context = this;

        if (context.$route.query.id) {
            TryoutService.getTryoutById(
                context.$route.query.id,
                function (result) {
                    if (result.success) {
                        context.tryout = result.data;
                        context.$store.commit("tryout_init", result.data);

                        context.tryout.start_date = {
                            value: context.tryout.start_date,
                            option: false,
                        };
                        context.tryout.end_date = {
                            value: context.tryout.end_date,
                            option: false,
                        };
                        context.tryout.start_time = {
                            value: context.tryout.start_time,
                            option: false,
                        };
                        context.tryout.end_time = {
                            value: context.tryout.end_time,
                            option: false,
                        };
                    }
                },
            );
        }

        DatepickerPlugin.init("#startDate", function (value) {
            context.tryout.start_date.value = moment(
                value,
                "DD/MM/YYYY",
            ).format("YYYY-MM-DD");
        });

        DatepickerPlugin.init("#endDate", function (value) {
            context.tryout.end_date.value = moment(value, "DD/MM/YYYY").format(
                "YYYY-MM-DD",
            );
        });

        ClockpickerPlugin.init("#startTime", function (value) {
            context.tryout.start_time.value = value + ":00";
        });

        ClockpickerPlugin.init("#endTime", function (value) {
            context.tryout.end_time.value = value + ":00";
        });
    },

    watch: {
        "tryout.type": function (val) {
            if (val != "SBMPTN") this.tryout.category = "OTHER";
        },
    },
};
</script>

<style scoped>
.jenjang-selection {
    background: #fbfbfb;
    /* Monochrome/Line Stroke */

    border: 1px solid #ebebeb;
    box-sizing: border-box;
    border-radius: 5000px;
}
</style>



// WEBPACK FOOTER //
// TryoutForm.vue?4309a077